<template>
  <div class="py-2">
    <!-- With assigned plan -->
    <div
      v-if="planSource"
      class="rounded-lg border border-border bg-gray-50 px-4 py-4 flex items-center justify-between gap-4"
    >
      <div class="flex items-center gap-3 min-w-0">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white border border-border">
          <CreditCard class="w-4 h-4 text-gray-500" />
        </div>
        <div class="min-w-0">
          <p class="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Assigned Plan</p>
          <p class="text-sm font-semibold text-gray-900 leading-snug">{{ planSource.name }}</p>
          <p v-if="planSource?.description" class="text-xs text-muted-foreground mt-0.5">{{ planSource.description }}</p>
        </div>
      </div>
      <div class="shrink-0 flex flex-col items-end gap-2">
        <div class="text-right">
          <p class="text-base font-semibold text-gray-900 leading-none">{{ planDisplayAmount }}</p>
          <p v-if="planIntervalLabel" class="text-xs text-muted-foreground mt-0.5">/ {{ planIntervalLabel }}</p>
        </div>
        <button
          @click="$emit('subscribe')"
          class="inline-flex items-center px-3 py-1.5 bg-cosmicPurple text-white text-xs font-medium rounded-md hover:bg-cosmicPurple/90 transition-colors"
        >
          Choose Plan
        </button>
      </div>
    </div>

    <!-- No plan -->
    <div
      v-else
      class="rounded-lg border border-border bg-gray-50 px-4 py-4 flex items-center justify-between gap-4"
    >
      <div class="flex items-center gap-3 min-w-0">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white border border-border">
          <CreditCard class="w-4 h-4 text-gray-400" />
        </div>
        <div>
          <p class="text-sm font-medium text-gray-900">No Active Monthly Tuition Plan</p>
          <p class="text-xs text-muted-foreground mt-0.5 leading-snug">Complete your monthly tuition payment to access all features</p>
        </div>
      </div>
      <button
        @click="$emit('subscribe')"
        class="shrink-0 inline-flex items-center px-3 py-1.5 bg-cosmicPurple text-white text-xs font-medium rounded-md hover:bg-cosmicPurple/90 transition-colors"
      >
        Choose Plan
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CreditCard } from 'lucide-vue-next'
import type { Plan } from '@/types/subscription'
import { formatPlanAmount, resolveIntervalLabel } from '@/components/subscription/SubscriptionStatus/helpers'

interface Props {
  planSource?: Plan | null
}

const props = defineProps<Props>()

defineEmits<{
  subscribe: []
}>()

const planDisplayAmount = computed(() => formatPlanAmount(props.planSource ?? null))
const planIntervalLabel = computed(() => resolveIntervalLabel(props.planSource ?? null))
</script>
